import { render, staticRenderFns } from "./wx_set.vue?vue&type=template&id=efe27a3a&scoped=true&"
import script from "./wx_set.vue?vue&type=script&lang=js&"
export * from "./wx_set.vue?vue&type=script&lang=js&"
import style0 from "./wx_set.vue?vue&type=style&index=0&id=efe27a3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe27a3a",
  null
  
)

export default component.exports